/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_No_ResultsInputs */

const en_explorer_search_no_results = /** @type {(inputs: Explorer_Search_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching records found.`)
};

const fr_explorer_search_no_results = /** @type {(inputs: Explorer_Search_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching records found.`)
};

const de_explorer_search_no_results = /** @type {(inputs: Explorer_Search_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching records found.`)
};

const it_explorer_search_no_results = /** @type {(inputs: Explorer_Search_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching records found.`)
};

const ru_explorer_search_no_results = /** @type {(inputs: Explorer_Search_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching records found.`)
};

const es_explorer_search_no_results = /** @type {(inputs: Explorer_Search_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching records found.`)
};

const zh_cn2_explorer_search_no_results = /** @type {(inputs: Explorer_Search_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching records found.`)
};

const ja_explorer_search_no_results = /** @type {(inputs: Explorer_Search_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching records found.`)
};

const hi_explorer_search_no_results = /** @type {(inputs: Explorer_Search_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching records found.`)
};

const pt_pt2_explorer_search_no_results = /** @type {(inputs: Explorer_Search_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching records found.`)
};

/**
* | output |
* | --- |
* | "No matching records found." |
*
* @param {Explorer_Search_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_no_results = /** @type {((inputs?: Explorer_Search_No_ResultsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_No_ResultsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_no_results(inputs)
	if (locale === "de") return de_explorer_search_no_results(inputs)
	if (locale === "it") return it_explorer_search_no_results(inputs)
	if (locale === "ru") return ru_explorer_search_no_results(inputs)
	if (locale === "es") return es_explorer_search_no_results(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_no_results(inputs)
	if (locale === "ja") return ja_explorer_search_no_results(inputs)
	if (locale === "hi") return hi_explorer_search_no_results(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_no_results(inputs)
	return en_explorer_search_no_results(inputs)
});